export type UserRoleRange = Readonly<{min: number; max: number}>;

export const USER_ROLE_PATIENT: UserRoleRange = {min: 1, max: 10} as const;
export const USER_ROLE_PROVIDER: UserRoleRange = {min: 21, max: 30} as const;
export const USER_ROLE_ORGANIZATION: UserRoleRange = {min: 41, max: 50} as const;
export const USER_ROLE_SUPER_ADMINISTRATOR: UserRoleRange = {min: 91, max: 100} as const;

export function isRoleInRange(roleId: unknown, range: UserRoleRange): boolean {
    const numeric = typeof roleId === 'number' ? roleId : typeof roleId === 'string' ? Number(roleId) : NaN;
    return Number.isFinite(numeric) && numeric >= range.min && numeric <= range.max;
}

export function isPatientRole(roleId: unknown): boolean {
    return isRoleInRange(roleId, USER_ROLE_PATIENT);
}

export function isProviderRole(roleId: unknown): boolean {
    return isRoleInRange(roleId, USER_ROLE_PROVIDER);
}

export function isOrganizationRole(roleId: unknown): boolean {
    return isRoleInRange(roleId, USER_ROLE_ORGANIZATION);
}

export function isSuperAdministratorRole(roleId: unknown): boolean {
    return isRoleInRange(roleId, USER_ROLE_SUPER_ADMINISTRATOR);
}
